import { useFetch } from "../../../hooks/api";
import { useAppSelector } from "../../../redux/hooks";
import useDSPSellerInfo from "./useDSPSellerInfo";

export const useDSPLineItemCreativeAssociationData = (adGroupId) => {
  const { marketPlace } = useAppSelector((state) => state.marketPlace);
  const { dspAdvertiser } = useDSPSellerInfo();

  const { data, isLoading } = useFetch(
    ["dspLineItemCreativeAssociations", adGroupId, dspAdvertiser?.id],
    "/dsp/adcreativeassociation",
    { ad_group_id: adGroupId, marketplace: marketPlace, dsp_seller_info_id: dspAdvertiser?.id },
    {
      select: (res) => {
        return res.data?.results ?? [];
      },
      default: [],
      staleTime: 60 * 5 * 1000,
    },
  );

  return { data, isLoading };
};
